import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  activeUserAtom,
  isActiveUserArtistAtom,
  isActiveUserEngineerAtom,
  isActiveUserStudioManagerAtom,
} from "../../../../atoms/user/activeUserAtom";
import { SCREENS } from "../../../../routes/screens";
import { MyMusicMenu } from "../MyMusicMenu/MyMusicMenu";
import { getNavButtonColor } from "../utils";
import {
  NAV_BUTTON_VARIANT,
  NavButton,
} from "./components/NavButton/NavButton";

/**
 * Meant to display an icon on the right side of the TopNav bar.
 */
export const NavigationRowMobile = () => {
  const activeUser = useAtomValue(activeUserAtom);
  const isEngineer = useAtomValue(isActiveUserEngineerAtom);
  const isArtist = useAtomValue(isActiveUserArtistAtom);
  const isStudioManager = useAtomValue(isActiveUserStudioManagerAtom);
  const isEngineerOrStudioManager = useMemo(
    () => isEngineer || isStudioManager,
    [isEngineer, isStudioManager],
  );
  const { pathname } = useLocation();

  // Don't show menu if user is not logged in
  if (!activeUser) {
    return null;
  }

  return (
    <Box position="absolute" right={17}>
      {isEngineerOrStudioManager && <MyMusicMenu showIconOnly />}
      {isArtist && !isEngineerOrStudioManager && (
        <NavButton
          variant={NAV_BUTTON_VARIANT.LINK}
          frontIcon={
            <FontAwesomeIcon
              color={getNavButtonColor([SCREENS.SEARCH], pathname)}
              icon={faSearch}
              size="xl"
            />
          }
          message="Search"
          path={SCREENS.SEARCH}
          showIconOnly
          color={getNavButtonColor([SCREENS.SEARCH], pathname)}
        />
      )}
    </Box>
  );
};
